export const getLink = (guid, fileName) => {
	if (process.env.NODE_ENV !== 'production') {
		return 'http://192.168.84.101:8080/rest-service/file/download/' + guid + '/' + fileName
	}
	return '/rest-service/file/download/' + guid + '/' + fileName
};



// WEBPACK FOOTER //
// ./src/utils/files.js